{
  "preview_error": "Kunde inte ladda sessionsförhandsvisning",
  "steps": "Steg",
  "load_error": "Kunde inte ladda session",
  "step_not_found": "Steg hittades inte",
  "next": "Nästa",
  "continue": "Fortsätt",
  "finish": "Avsluta",
  "exit": "Avsluta",
  "finish_heading": "Bra gjort {{name}}.",
  "finish_subheading": "Alla steg klara!",
  "back_to_dashboard": "Till dashboard",
  "back_to_library": "Till biblioteket"
}
